export const BACKEND_GRAPHQL_SERVER = 'backend-graphql';
